import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiArrowUpRight} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20would%20love%20to%20visit%20your%20atelier.';

function StorySection() {
  return (
    <section id="story" className="bg-[#1F3D2E] py-24 md:py-32 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 md:gap-20 items-center">
        <motion.div initial={{opacity: 0,x: -40}} whileInView={{opacity: 1,x: 0}} viewport={{once: true,amount: 0.3}} transition={{duration: 0.7}} className="relative">
          <div className="aspect-[4/5] overflow-hidden">
            <img src="https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1200&q=85" alt="Aurelle atelier" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#B87333] p-8 max-w-[200px] hidden md:block">
            <span className="font-display text-5xl text-[#1F1B17] block leading-none">12</span>
            <span className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#1F1B17] mt-2 block">Years of quietly beautiful craft</span>
          </div>
        </motion.div>
        <motion.div initial={{opacity: 0,x: 40}} whileInView={{opacity: 1,x: 0}} viewport={{once: true,amount: 0.3}} transition={{duration: 0.7}}>
          <p className="eyebrow mb-6" style={{color: '#B87333'}}>A note from the atelier</p>
          <h2 className="font-display text-[clamp(36px,5vw,56px)] leading-[1.1] text-[#F7F2EA] font-light">
            Less rush.<br /><em className="italic text-[#B87333]">More feeling.</em>
          </h2>
          <p className="mt-8 font-sans text-base text-[#F7F2EA]/75 leading-loose max-w-md">
            Aurelle began with a simple idea — that every woman deserves pieces that feel like they were made for her. We edit relentlessly,choose fabrics that breathe,and finish every garment so it moves the way you do.
          </p>
          <p className="mt-5 font-sans text-base text-[#F7F2EA]/75 leading-loose max-w-md">
            From boardroom mornings to wedding evenings,our rails are curated for the life you actually live.
          </p>
          <p className="mt-8 font-display text-xl italic text-[#B87333]">That is the Aurelle feeling.</p>
          <a href={WA} target="_blank" rel="noreferrer" className="group mt-8 inline-flex items-center gap-3 border-b border-[#B87333]/50 pb-2 font-sans text-[11px] tracking-[0.2em] uppercase text-[#B87333] hover:border-[#B87333] transition">
            Visit the atelier <SafeIcon icon={FiArrowUpRight} className="group-hover:translate-x-1 transition" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default StorySection;
